// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { KLRulesButtonBackground } from '../../assets/img/buttons';
import SharedStyle from '../../styled-component/shared';

const Wrapper = styled.div`
  width: 20%;
  cursor: pointer;

  ${SharedStyle.ImageAsButtonsBehaviour}
`;

const Background = styled.img`
  object-fit: cover;
  width: 100%;
`;

type KLRulesButtonProps = {
  onClick: () => void;
  className?: string;
};

const KLRulesButton = ({ onClick = () => {}, className = '' }: KLRulesButtonProps) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <Background src={KLRulesButtonBackground} alt="" />
    </Wrapper>
  );
};

export default KLRulesButton;
